'use strict';

(function ($) {

	$("document").ready(function () {

		$('.fonts-big-js').on('click', function (e) {
			e.preventDefault();
			let fs = parseInt($('html').css('font-size'));
			if (fs < 20) {
				fs += 2;
				localStorage.setItem('font-size', fs);
				if (fs > 16) {
					$(".fonts-big-js").addClass("active");
					$(".fonts-small-js").removeClass("active");
				}
				if (fs == 16) {
					$(".fonts-small-js").removeClass("active");
					$(".fonts-big-js").removeClass("active");
				}
				$('html').css('font-size', fs);
			}
		});

		$('.fonts-small-js').on('click', function (e) {
			e.preventDefault();
			let fs = parseInt($('html').css('font-size'));
			if (fs > 12) {
				fs -= 2;
				localStorage.setItem('font-size', fs);
				if (fs < 16) {
					$(".fonts-small-js").addClass("active");
					$(".fonts-big-js").removeClass("active");
				}
				if (fs == 16) {
					$(".fonts-small-js").removeClass("active");
					$(".fonts-big-js").removeClass("active");
				}
				$('html').css('font-size', fs);
			}
		});

		$('.fonts-middle-js').on('click', function (e) {
			e.preventDefault();
			localStorage.setItem('font-size', 16);
			$(".fonts-small-js").removeClass("active");
			$(".fonts-big-js").removeClass("active");
			$('html').css('font-size', 16);
		});


		function change_font_size() {
			let get_change_fonts = parseInt(localStorage.getItem("font-size"));
			if (get_change_fonts) {
				$('html').css('font-size', get_change_fonts);
				if (get_change_fonts > 16) {
					$(".fonts-big-js").addClass("active");
					$(".fonts-small-js").removeClass("active");
				}
				if (get_change_fonts < 16) {
					$(".fonts-small-js").addClass("active");
					$(".fonts-big-js").removeClass("active");
				}
				if (get_change_fonts == 16) {
					$(".fonts-big-js").removeClass("active");
					$(".fonts-small-js").removeClass("active");
				}
			} else {
				$("body").removeClass("fonts-js-active");
			}
		}
		change_font_size();

	});

})(jQuery);
